code

<template>

    <div class="container">
        <div class="row fh-row justify-content-center">
            <div class="col-md-6 pl-0 pr-0 align-self-center ">
                <mdb-card class="z-depth-1 card-height">
                    <mdb-card-header color="white">
                        <div class="container-fluid">
                            <div class="row">
                                <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                                  <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                                </div>
                                <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                                  <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                                </div>
                                <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                                  <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                                </div>
                            </div>
                        </div>
                    </mdb-card-header>
                    <mdb-card-body class="text-center">
                            <div class="container-fluid">
                                <div class="row hh-row ">
                                    <div class="col-12 align-self-center">
                                        <div class="row justify-content-center">
                                            <div class="col-9 ">
<!--                                              <img src="@/assets/login.png" alt class="img-fluid"/>-->
                                              <img :src="logo" alt class="img-fluid"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                      <div class="container">
                        <div class="row mb-3">
                          <div class="col">
                            <h5>Select Language /
                              زبان منتخب کریں
                            </h5>


                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <mdb-btn style="font-size: 15px" size="md"
                                     class="mw-75"
                                     :color="$store.state.language === 'en'? 'primary': 'white'"
                                     @click="changeLanguage('en')">
                              English
                            </mdb-btn>
                          </div>
                          <div class="col">
                            <mdb-btn style="font-size: 15px" size="md"
                                     class="mw-75"
                                     :color="$store.state.language === 'ur'? 'primary': 'white'"
                                     @click="changeLanguage('ur')">
                              اردو
                            </mdb-btn>
                          </div>
                        </div>
                      </div>
                    </mdb-card-body>
                  <mdb-card-footer>
                    <div class="container-fluid">
                      <div class="row justify-content-center">
                        <div class="col-md-12 mb-1 ">
                          <mdb-btn style="font-size: 15px" block color="primary" class="next-btn" size="md"
                                   :disabled="!validated"
                                   @click="navigate">
                            {{ $t("verify") }}
                            <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                          </mdb-btn>
                        </div>
                      </div>
                    </div>
                  </mdb-card-footer>
                </mdb-card>
            </div>
        </div>

        <div id="overlay" v-if="spinner">
            <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>

                </div>
                <p>{{ $t("waitMsg") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { i18n } from "../../translations";

    export default {
        name: "Login",
        components: {},
        data() {
          return {
            spinner:false,
            agents:[],
            selectedAgent:null,
            validated: false,
            latitude: null,
            longitude: null,
            userAgent: null,
            logo: null,
            reseller_logo: null,
            ipAddress: null,
          };
        },
        mounted() {
          this.spinner = true
          this.getLogo()
          this.getIP()
          i18n.locale = this.$store.state.language

          // Get location
          const success = (position) => {
            this.latitude  = position.coords.latitude;
            this.longitude = position.coords.longitude;
          };

          const error = (err) => {
            console.log(err)
          };

          // This will open permission popup
          navigator.geolocation.getCurrentPosition(success, error);

          this.userAgent = navigator.userAgent

          this.$store.state.step = 0

          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          this.query_params = params

          // this.getConfig()

          this.$localForageService.clear();
          this.$store.commit("setExtractTextState", {
            state: false,
            data: false
          });
          this.$store.commit("setTrustedPartnerState", {
            name:"",
            number:""
          });
          this.$store.commit("setSessionID",{
            session_id:null,
            agent_name:null
          })
          this.$store.commit('setManualVerification', {
            manual_verification: false
          })
          this.$store.commit('setSelectedAgent',{
            selected_agent:null
          })
          this.$store.commit('setResellerLogo', null)
          this.$store.commit('setExpiredMessage', "")
          this.$store.commit("setIDSelfieRequired", false)

          this.spinner = false
        },
        methods: {
          changeLanguage(language) {
            i18n.locale = language
            this.$store.commit('setLanguage', language)
          },
          getLogo() {
            this.$http.get('/get-client-logo/').then(res => {
              if (res.data) {
                this.logo = res.data.logo
                if (res.data.reseller_logo) {
                  this.$store.commit("setResellerLogo", res.data.reseller_logo)
                }
                this.validated = true
              } else {
                this.showError("Configuration Error")
              }
            }).catch(err => {
              this.handleError(err)
            })
          },
          getIP() {
            fetch('https://api.ipify.org?format=json').then(x => x.json()).then(({ ip }) => {
              this.ipAddress = ip
            });
          },
          getConfig() {
            let formData = new FormData
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            if (params.configuration) {
              formData.append('configuration', params.configuration)
            }
            this.$http.post('/get-config', formData).then(res => {
              if (res.data) {
                this.$store.state.totalSteps = res.data.path.length
                this.$store.commit('setConfig', {config: res.data.config, configPath: res.data.path})
              } else {
                this.showError("Configuration Error")
              }
            }).catch(err => {
              this.handleError(err)
            })
          },
          navigate() {
            this.spinner = true
            let formData = new FormData
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            if (this.longitude && this.latitude) {
              formData.append('latitude', this.latitude)
              formData.append('longitude', this.longitude)
            }
            if (this.userAgent) {
              formData.append('user_agent', this.userAgent)
            }
            if (this.ipAddress) {
              formData.append('ip_address', this.ipAddress)
            }
            console.log(params.configuration)
            if (params.configuration) {
              formData.append('configuration', params.configuration)
              delete params.configuration
            }
            formData.append('meta', params.meta)
            this.$http.post('/create-session', formData).then(res => {
              this.spinner = false
              this.$store.commit('setSessionID', {session_id:res.data.id})
              const config = res.data.configuration
              this.$store.state.totalSteps = config.path.length
              this.$store.commit('setConfig', {config: config.config, configPath: config.path})
              this.$router.push({path:this.$store.state.configPath[this.$store.state.step], query:params})
            }).catch(err => {
              this.handleError(err)
            })
          },
          showError(message, cancelButton=false) {
            const options = {
              title: message,
              text: this.$t("retryQuestion"),
              icon: 'question',
              showCancelButton: cancelButton,

              confirmButtonText: this.$t("yes"),
              cancelButtonText: this.$t("no"),
              allowOutsideClick: false,
              allowEscapeKey: false,
              focusConfirm: false,
              customClass: {
                confirmButton: "btn btn-primary btn-md ripple-parent",
                cancelButton: "btn  btn-md ripple-parent"
              },
              buttonsStyling: false,
            };

            this.$swal.fire(options).then(res => {
              if (res.value) {
                window.location.reload();
                // eslint-disable-next-line no-undef
              }
            })

          },
          handleError(err) {
            if (err.response) {
              if (err.response.status === 400){
                if ('non_field_errors' in err.response && err.response.non_field_errors.length>0){
                  this.showError(err.response.non_field_errors[0])
                }
                else if ('data' in err.response){
                  if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length>0){
                    this.showError(err.response.data.non_field_errors[0])
                  }
                  else{
                    if (Array.isArray(err.response.data) && err.response.data.length>0) {
                      let error = err.response.data[0]
                      if (typeof err.response.data[0] !== "string") {
                        error = JSON.stringify(error)
                      }
                      this.showError(error)
                    }
                    else {
                      this.showError(JSON.stringify(err.response.data))
                    }

                  }

                }
                else{
                  this.showError(JSON.stringify(err.response))
                }
              } else if (err.response && err.response.status === 401) {
                if (err.response.data && err.response.data.detail) {
                  this.$store.commit("setExpiredMessage", err.response.data.detail)
                }
                this.$router.push('/expired')
              }
              else {
                this.showError(err.response)
              }
            } else {
              this.showError("Error")
            }
            this.spinner = false
          }
        },

    };
</script>
<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

    $image-path: "~@/../mdb/mdbvue/img";

    .slide-fade-enter-active {
      transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
      /* .slide-fade-leave-active below version 2.1.8 */ {
      transform: translateX(10px);
      opacity: 0;
    }

    .input-text-center input {
      text-align: center !important;
    }

    .very-large-text input {
      font-size: 32px !important;
    }

    .file-content {
      height: 41vh;
      overflow-y: auto;
      padding: 3px;
    }

    .dot {
      height: 15px;
      width: 15px;
      background-color: #bbb;
      border-radius: 50%;
      display: inline-block;
      margin: 0 5px;
    }
    .blue {
      background-color: #004aad;
    }
    .img-banner {
      width: 41%;
    }

</style>
